export default __webpack_public_path__ + "static/media/2.47b4e0e4.jpg";